import styled from 'styled-components';

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DialogWrapper = styled.div`
  background-color: #fff;
  // padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.07);
  width: 500px;
  max-width: 100%;
  margin: 0 10px;
`;
